const NotFound = () => import('@/pages/NotFound')

export default [
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound
  },
  {
    path: '*',
    redirect: '/404'
  }
]



// WEBPACK FOOTER //
// ./src/router/errors.route.js